import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import {
    FormText,
    Container, Row, Col, Card, Table, CardBody, Label, Input, CardTitle, Button, FormGroup, Form,
    Collapse,
    Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemPanel, CardHeader
} from 'reactstrap';
import CustomModal from "../../constants/CustomModal";
import { apiService } from "../../constants/ApiService";

const SingleItemArray = ({ itemTable,
  getItemData, System_Records_receipted_data,
    helperMasterSingleItem, partyMasterId, partyMasterName,
    singleItemSelectArray, setSingleItemSelectArray, openSingleItemExtraDetailModel,
    OpenWarrantyModel, setDeletesingleItemSelectArray, openSingleItemModel, IrFlag,
    UpdateChallanMasterData, errorMessage, partyTable,
    nextIrFlag, nextIrFlagDetail, nextPartyOption, setRemoveNextChallanArray,
    challanMasterData
}) => {

    let initialSingleItem = {
        item_code: null,
        item_name: "",
        brand_id: "",
        brand: "",
        group: "",
        hsn_code: "",
        tax_per: "",
        convertion_of_pcs: "",
        price_purchase_rate: null,
        price_sell_rate: null,
        avg_weight_of_sell: null,
        price_opening_stock_rate: null,
        opening_stock_shop: null,
        stock_shop: null,
        opening_stock_godown: null,
        stock_godown: null,
        total_stock: null,
        item_type: "",
        recv_qty: 0,
        recv_qty: 0,
        item_gross_amount_one_pc: "",
        item_gst: "",
        item_gst_rate_one_pc: "",
        total_amount_with_gst_one_pc: "",
        item_hsn_code_one_pc: '',
        item_packing_type_one_pc: '',
        item_remarks_one_pc: '',

        item_gst_percenatge_one_pc: "",
        item_discount_rate_one_pc: "",
        rent_rate: "",
        item_discount_percentage_one_pc: 0,
        rent_rate: 0,
        item_weight_one_pc: null,
        itemWeight: null,
        irflag: IrFlag,
        item_scheme_type_one_pc: "",
        pname: "",
        pcode: null,
        itemtype: "",
        item_group_code: null
    }
    const [singleItemSelect, setSingleItemSelect] = useState(initialSingleItem)
    const [helperMasterSingleItemWarrantyPeriod, setHelperMasterSingleItemWarrantyPeriod] = useState([])

    const [brandTable, setBrandTable] = useState([]);
    const [openAccordion, setOpenAccordion] = useState(1);

    const getBrandData = async (page = 1, limit = 10, search = "") => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            };

            if(singleItemSelect.brand !== "") {
                search = singleItemSelect.brand;
            }

            const response = await apiService.get(
                `/api/BrandMaster/allbrands?pageNo=${page}&limit=${limit}&searchKey=${search}&vendorId=${challanMasterData?.vender_master_id}&branchId=${challanMasterData?.branch_master_id}`,
                config
            );

            //console.log(response, "brand response")

            if (response.response && response.response.data.errors) {
                alert(response.response?.data?.errors);
                return;
            }

            if (response.status === true) {
                const brandtbl = response.brandMasterData;
                setBrandTable(
                    brandtbl.map(b => ({ id: b.id, label: b.brand_name }))
                );
                //setBrandTable(response.brandMasterData || []);
            } else {
                console.log(response.message);
            }
        } catch (error) {
            console.error(error);
            alert("Something went wrong!!");
        }
    };


    const onChangeSingleItemHandle = (e) => {
        const { name, value } = e.target;

        console.log(name, value)

        if (name == "item_warranty_period") {

            setSingleItemSelect((prevData) => ({
                ...prevData,
                [name]: value,
                item_warranty_expiry_date: calculateWarrantyExpiryDate(value)
            }));

        } else {
            setSingleItemSelect((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    function calculateWarrantyExpiryDate(condition) {
        let currentDate = new Date();

        // Log the current date
        console.log("Current Date:", currentDate);

        // Initialize expiry date as the current date
        let expiryDate = new Date(currentDate);

        // Parse condition for months and years
        const match = condition.match(/(\d+)\s*(Months?)/i);
        const year = condition.match(/(\d+)\s*(Years?)/i);

        // Check for months
        if (match) {
            let value = parseInt(match[1], 10); // Extract numeric value for months
            expiryDate.setMonth(expiryDate.getMonth() + value);
        }

        // Check for years
        if (year) {
            let value = parseInt(year[1], 10); // Extract numeric value for years
            expiryDate.setFullYear(expiryDate.getFullYear() + value);
        }

        // Format the date to YYYY-MM-DD for input tag
        let formattedDate = expiryDate.toISOString(); // Get date in YYYY-MM-DD format

        console.log("Expiry Date:", formattedDate);
        return formattedDate;
    }




    // const addMore = () => {

    //     const lastItem = singleItemSelectArray[0];

    //     // undefined add the  default value  
    //     if (lastItem == undefined) {
    //         const updatedArray = [...singleItemSelectArray,{ ...initialSingleItem }, ];
    //         const arrayWithSerials = updatedArray.map((item, index) => ({
    //             ...item,
    //             // serial_no: String( index + 1)
    //             serial_no: String(updatedArray.length - index)

    //         }));
    //         setSingleItemSelectArray(arrayWithSerials);

    //         return
    //     }

    //     //console.log(lastItem, "lastItemlastItem")

    //     //Check if item is selected and quantity is entered
    //     if (!lastItem?.item_code || (!lastItem.recv_qty && !lastItem.issue_qty)) {
    //         alert("Please select an item and enter quantity before adding more.");
    //         return;
    //     }

    //     const updatedArray = [{ ...initialSingleItem }, ...singleItemSelectArray,];
    //     //console.log(updatedArray, "updatedArrayupdatedArray");

    //     // updatedArray.sort((a, b) => {
    //     //     const aQty = parseFloat(a.recv_qty || 0) + parseFloat(a.issue_qty || 0);
    //     //     const bQty = parseFloat(b.recv_qty || 0) + parseFloat(b.issue_qty || 0);
    //     //     return aQty - bQty;
    //     // });

    //     // Assign serial_no to each item based on new order
    //     const arrayWithSerials = updatedArray.map((item, index) => ({
    //         ...item,
    //         // serial_no: String( index + 1)
    //         serial_no: String(updatedArray.length - index)

    //     }));
    //     setSingleItemSelectArray(arrayWithSerials);

    //     // setSingleItemSelectArray(updatedArray);
    // };


    // Function to update an object in the array based on index

    const addMore = () => {
        const lastItem = singleItemSelectArray[singleItemSelectArray.length - 1];

        // 👉 If no item exists
        if (!lastItem) {
            const updatedArray = [{ ...initialSingleItem }];

            const arrayWithSerials = updatedArray.map((item, index) => ({
                ...item,
                serial_no: String(index + 1)
            }));

            setSingleItemSelectArray(arrayWithSerials);
            return;
        }

        // 👉 Validation
        if (!lastItem?.item_code || (!lastItem.recv_qty && !lastItem.issue_qty)) {
            alert("Please select an item and enter quantity before adding more.");
            return;
        }

        // ✅ Add at LAST (fixed)
        const updatedArray = [...singleItemSelectArray, { ...initialSingleItem }];

        // ✅ Serial numbers (normal order now)
        const arrayWithSerials = updatedArray.map((item, index) => ({
            ...item,
            serial_no: String(index + 1)
        }));

        setSingleItemSelectArray(arrayWithSerials);
    };

    const updateSingleArrayItem = (index, field, value) => {
        if (field == "next_challan_party_id") {

            if (!value) {
                setSingleItemSelectArray((prevArray) =>
                    prevArray.map((item, i) =>
                        i === index ? {
                            ...item,
                            [field]: null,
                            "next_challan_party_name": "",
                            "next_irflag": "",
                            "next_irflag_detail": "",

                            "next_tds_option": "no",
                            "next_tds_master_id": null,
                            "next_tds_rate": null

                        } : item
                    )
                );
            } else {

                let findPartyData = partyTable.find((data) => data.id == value?.id)

                setSingleItemSelectArray((prevArray) =>
                    prevArray.map((item, i) =>
                        i === index ? {
                            ...item,
                            [field]: value?.id,
                            "next_challan_party_name": value?.name,
                            "next_irflag": nextIrFlag,
                            "next_irflag_detail": nextIrFlagDetail,

                            "next_tds_option": findPartyData.tds_option,
                            "next_tds_master_id": findPartyData.tds_master_id,
                            "next_tds_rate": findPartyData.tds_rate
                        } : item
                    )
                );
            }


            let challanNoToUpdate = singleItemSelectArray[index]?.next_challan_no;
            console.log(challanNoToUpdate, "challanNoToUpdatechallanNoToUpdate@@@@@@")
            if (challanNoToUpdate) {
                setSingleItemSelectArray((prevArray) => {

                    return prevArray.map((item) => {
                        if (item.next_challan_no === challanNoToUpdate) {
                            return {
                                ...item,
                                [field]: value?.id,
                                next_challan_party_name: value?.name,
                                next_irflag: nextIrFlag,
                                next_irflag_detail: nextIrFlagDetail
                            };
                        } else {
                            return item;
                        }
                    });
                });
            }




        } else {
            setSingleItemSelectArray((prevArray) =>
                prevArray.map((item, i) =>
                    i === index ? { ...item, [field]: value || null } : item
                )
            );
        }


    };



    const handleSingleArrayItem = (event, value, index) => {
        setSingleItemSelectArray((prevArray) => {
            const updatedArray = [...prevArray];

            if (!value) {
                // Handle cleared value - reset or remove item
                if (updatedArray[index]) {
                    updatedArray[index] = {
                        serial_no: updatedArray[index].serial_no || index + 1 // Keep serial number
                    };
                }
                return updatedArray;
            }

            const findItemData = itemTable.find((data) => data.id === value.id);
            let totalOpeningQty = 0;

            if (findItemData?.challanTransDetail?.length > 0) {
                totalOpeningQty = findItemData.challanTransDetail.reduce(
                    (acc, detail) => acc + (detail?.recv_qty ?? 0),
                    0
                );
            }

            if (findItemData) {
                const existingSerialNo = updatedArray[index]?.serial_no || index + 1;

                const newItem = {
                    ...findItemData,
                    rent_rate: findItemData.price_sell_rate || 0,
                    item_purchase_one_pc: findItemData.price_purchase_rate || 0,
                    item_profit_one_pc:
                        (findItemData.price_sell_rate || 0) - (findItemData.price_purchase_rate || 0),
                    item_hsn_code_one_pc: findItemData.hsn_code || "",
                    item_packing_type_one_pc: findItemData.item_packing_type || "",
                    item_discount_percentage_one_pc: findItemData.price_sell_discount_percentage || null,
                    item_gst_percenatge_one_pc: findItemData.price_sell_gst_percentage || null,
                    item_weight_one_pc: findItemData.avg_weight_of_sell || "",

                    item_code: findItemData.id || null,
                    item_group_name: findItemData.group || "",
                    item_current_stock: findItemData.total_stock || 0,
                    opening_qty: totalOpeningQty,
                    pname: partyMasterName,
                    pcode: partyMasterId,
                    itemtype: findItemData.item_type || "",
                    item_group_code: findItemData.group_id || null,
                    item_scheme_type_one_pc: "chargeable",
                    item_warranty_mode: "",
                    item_warranty_period: findItemData.warranty_period || "",
                    item_warranty_visit_count: "",
                    item_warranty_expiry_date:
                        findItemData.warranty_yes_no === "yes"
                            ? calculateWarrantyExpiryDate(findItemData.warranty_period)
                            : null,
                    irflag: IrFlag,
                    serial_no: String(existingSerialNo)
                };

                updatedArray[index] = newItem;
            }

            return updatedArray;
        });
    };


    const [showSingleItemDetailModel, setShowSingleItemDetailModel] = useState(false);
    const [showSingleItemDetail, setShowSingleItemDetail] = useState({})
    const OpenSingleItemDetailModel = (index) => {

        let findArray = singleItemSelectArray[index];

        console.log(findArray, "findArrayfindArrayfindArray")

        setShowSingleItemDetail(findArray)
        setShowSingleItemDetailModel(true)
    }

    const ClosedSingleItemDetailModel = () => {
        setShowSingleItemDetailModel(false)
    }
    useEffect(() => {
        getBrandData();
    }, []);

    useEffect(() => {
        // if (billMethod === "single") {
        // const updatedItems = singleItemSelectArray.map((item) => {
        //     const qty = parseFloat(item.recv_qty || 0);
        //     const sellRate = parseFloat(item.rent_rate);
        //     const discountPercent = parseFloat(item.item_discount_percentage_one_pc) || 0;
        //     const profit = parseFloat(item.rent_rate - item.item_purchase_one_pc) || 0;
        //     let itemWeight = parseFloat(item.item_weight);

        //     // Calculate total weight based on qty
        //     let totalWeight = qty ? itemWeight * qty : itemWeight;

        //     // Amount calculations
        //     const totalBeforeDiscount = qty * sellRate;
        //     const discountAmount = (totalBeforeDiscount * discountPercent) / 100;
        //     const totalAfterDiscount = totalBeforeDiscount - discountAmount;

        //     // Discount calculations
        //     const discountAmt = (sellRate * discountPercent) / 100;
        //     const discountRate = parseFloat(item.price_sell_rate) || 0 - parseFloat(discountAmt) || 0;

        //     // Gross amount
        //     const grossAmount = totalBeforeDiscount - discountAmount;

        //     // GST calculations
        //     const gstPercent = parseFloat(item.item_gst_percenatge_one_pc) || 0;
        //     const gstAmount = (grossAmount * gstPercent) / 100;
        //     const itemGstAmount = (gstPercent * parseFloat(item.item_discount_rate_one_pc) || 0) / 100;

        //     return {
        //         ...item,
        //         item_profit_one_pc: profit,
        //         profit_amount_one_pc: qty * profit || 0,
        //         item_gross_amount_one_pc: grossAmount,
        //         item_discount_amount_one_pc: discountAmt.toFixed(2),
        //         item_discount_rate_one_pc: discountRate.toFixed(2),
        //         item_rate_after_gst_one_pc: discountRate + itemGstAmount,
        //         item_gst_percenatge_one_pc: gstPercent,
        //         item_gst_rate_one_pc: gstAmount.toFixed(2),
        //         item_gst_amt_one_pc: itemGstAmount,
        //         total_amount_with_gst_one_pc: grossAmount + gstAmount,
        //         item_weight_one_pc: totalWeight,
        //     };
        // });

        const updatedItems = singleItemSelectArray.map((item) => {
            const qty = parseFloat(item.recv_qty || item.issue_qty) || 0;
            const sellRate = parseFloat(item.rent_rate) || 0;
            const discountPercent = parseFloat(item.item_discount_percentage_one_pc) || 0;
            const profit = parseFloat(item.rent_rate - (item.item_purchase_one_pc || 0)) || 0;
            let itemWeight = parseFloat(item.item_weight_one_pc) || 0;

            // Calculate total weight based on qty
            let totalWeight = qty ? itemWeight * qty : itemWeight * qty;

            // Amount calculations
            const totalBeforeDiscount = qty * sellRate || 0;
            const discountAmount = (totalBeforeDiscount * discountPercent) / 100 || 0;
            const totalAfterDiscount = totalBeforeDiscount - discountAmount || 0;

            // Discount calculations
            const discountAmt = (sellRate * discountPercent) / 100 || 0;
            // const discountRate = (parseFloat(item.price_sell_rate) || 0) - discountAmt || 0;
            const discountRate = (parseFloat(item.rent_rate) || 0) - discountAmt || 0;

            // Gross amount
            const grossAmount = totalBeforeDiscount - discountAmount || 0;

            // GST calculations
            const gstPercent = parseFloat(item.item_gst_percenatge_one_pc) || 0;
            const gstAmount = (grossAmount * gstPercent) / 100 || 0;
            const itemGstAmount = ((gstPercent * (parseFloat(item.item_discount_rate_one_pc) || 0)) / 100) || 0;

            return {
                ...item,
                item_profit_one_pc: profit,
                profit_amount_one_pc: (qty * profit) || 0,
                item_gross_amount_one_pc: Number(grossAmount?.toFixed(2)),
                item_discount_amount_one_pc: discountAmt?.toFixed(2),
                item_discount_rate_one_pc: discountRate?.toFixed(2),
                // item_rate_after_gst_one_pc: (discountRate + itemGstAmount) || 0,
                item_rate_after_gst_one_pc: Number(((discountRate || 0) + (itemGstAmount || 0)).toFixed(2)),

                item_gst_percenatge_one_pc: gstPercent,
                item_gst_rate_one_pc: gstAmount?.toFixed(2),
                item_gst_amt_one_pc: itemGstAmount,
                total_amount_with_gst_one_pc: Number(
                    ((grossAmount || 0) + (gstAmount || 0)).toFixed(2)
                ),
                item_weight_one_pc: itemWeight,
                totalWeight: totalWeight
            };
        });


        // Only update state if the new array is different
        if (JSON.stringify(updatedItems) !== JSON.stringify(singleItemSelectArray)) {
            setSingleItemSelectArray(updatedItems);
        }
        // }
    }, [singleItemSelectArray]);


    // const RemoveSingleArraySelectItem = (index) => {
    //     setSingleItemSelectArray((prevState) => {

    //         if (index < 0 || index >= prevState.length) return prevState; // Ensure index is valid
    //         const itemToRemove = prevState[index];
    //         const updatedArray = prevState.filter((_, i) => i !== index);


    //         if (itemToRemove) {
    //             setDeletesingleItemSelectArray((prevDeleteState) => [...prevDeleteState, itemToRemove]);
    //         }
    //         return updatedArray;
    //     });
    // };

    const RemoveSingleArraySelectItem = (index) => {

        // Ask for confirmation before deletion
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");
        if (!isConfirmed) {
            alert("Delete cancelled.");
            return;
        }


        setSingleItemSelectArray((prevState) => {

            if (index < 0 || index >= prevState.length) return prevState; // Ensure index is valid
            const itemToRemove = prevState[index];

            // Use `let` for variables that may be reassigned
            let updatedArray = prevState.filter((_, i) => i !== index);  // Filtering out the item

            // Reassign serial_no only if it was > 0
            // First, calculate the number of items with serial_no > 0
            let count = updatedArray.filter(item => item.serial_no > 0).length;
            let serialCounter = count;

            updatedArray = updatedArray.map((item) => {
                if (item.serial_no > 0) {
                    return { ...item, serial_no: String(serialCounter--) };  // Assign reverse serial_no
                }
                return item;  // Keep as is if serial_no <= 0
            });


            // Store the removed item (optional)
            if (itemToRemove) {
                setDeletesingleItemSelectArray((prevDeleteState) => [...prevDeleteState, itemToRemove]);
            }

            return updatedArray;
        });
    };


    const handleRemoveNextChallanData = (id) => {
        setSingleItemSelectArray((prevList) =>
            prevList.map((item) => {
                if (item.id === id) {

                    // Extract the removed fields
                    // Save to separate state
                    setRemoveNextChallanArray((prev) => [...prev, item]);

                    // Return item with values cleared
                    return {
                        ...item,
                        next_challan_party_id: "",
                        next_challan_party_name: "",
                        next_challan_no: "",
                        next_irflag: "",
                        next_irflag_detail: "",
                    };
                }
                return item;
            })
        );
    };


    const toggleAccordion = (index) => {
        setOpenAccordion((prevIndex) => (prevIndex === index ? null : index));
    };

    return (
        <>
            <div className="card border-0 shadow-sm mb-3">
                <div className="card-header bg-white border-bottom d-flex align-items-center justify-content-between py-3 px-4" onClick={() => toggleAccordion(1)}
                    role="button">
                    <h6 className="mb-0 font-weight-bold text-dark">
                        <i className="bi bi-box mr-2 text-danger"></i> Item Details
                    </h6>

                    <i className={`bi ${openAccordion === 1 ? "bi-chevron-up" : "bi-chevron-down"} text-muted`}></i>

                </div>
                <Collapse isOpen={openAccordion === 1}>

                    <div className="card-body">
                        <div className="text-right mb-3">
                            <Button color="primary" size="sm" onClick={() => openSingleItemModel()}>
                                <i className="bi bi-plus-circle" /> Add New Item
                            </Button>
                        </div>

                        {errorMessage.singleItem && (
                            <FormText color="danger" className="d-block mb-2">
                                {errorMessage.singleItem}
                            </FormText>
                        )}

                        {singleItemSelectArray.map((singleItemSelect, index) => {
                          const selectedItem =
    singleItemSelect?.item_code && singleItemSelect?.item_name
      ? { id: singleItemSelect.item_code, label: singleItemSelect.item_name }
      : null;

  const baseOptions = itemTable.map(o => ({
    id: o.id,
    label: o.item_name
  }));

  const options =
    selectedItem &&
    !baseOptions.some(o => o.id === selectedItem.id)
      ? [selectedItem, ...baseOptions]
      : baseOptions;
                        return (

                            <div key={index} className="position-relative mb-3">

                                {/* Serial badge */}
                                <span className="badge bg-primary position-absolute rounded-pill text-white"
                                    style={{ top: -10, left: -10, fontSize: 11, padding: "5px 9px", zIndex: 1 }}>
                                    {singleItemSelect.serial_no}
                                </span>

                                <div className="border rounded p-3 bg-white shadow-sm">

                                    <Row className="g-2">
                                        <Col xs={6} sm={6} md={6} lg={6} className="mb-2">

                                    <FormGroup className="mb-3">
                                        <Label style={{ fontSize: 14, fontWeight: 600 }}>
                                            {singleItemSelect.serial_no}. Item Name
                                        </Label>
                                         <Autocomplete
                id={`item_name_${index}`}
                options={options}
                value={selectedItem}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(e, v) => handleSingleArrayItem(e, v, index)}
                onInputChange={(e, inputValue, reason) => {
    if (reason === "input") {
      getItemData(1, 10, inputValue, partyMasterId);
    }
  }}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
                                    </FormGroup>
                                        </Col>

                                        <Col xs={6} sm={6} md={6} lg={6} className="mb-2">
                                            <FormGroup className="mb-3">
                                                <Label style={{ fontSize: 14, fontWeight: 600 }}>
                                                    Brand Name
                                                </Label>
                                                <Autocomplete
                                                    options={brandTable}
                                                    getOptionLabel={(option) => option?.label || ''}
                                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                                    value={brandTable.find(b => b.id === singleItemSelect?.brand_id) || null}
                                                    onChange={(e, value) => updateSingleArrayItem(index, "brand_id", value?.id || null)}
                                                    renderInput={(params) => <TextField {...params} size="small" />}
                                                />
                                            </FormGroup>

                                        </Col>

                                    </Row>

                                    <hr className="my-2" />

                                    <Row className="g-2">



                                        {false && <Col xs={12} xl={3}>

                                            <Label style={{ fontSize: 14 }} for="item_name">Action</Label>
                                            <FormGroup style={{ padding: 1, display: "flex", gap: 5 }} > {/* Adjust width as needed */}
                                                {System_Records_receipted_data?.extra_detail_button == "yes" && <Button type="button" className="mt-2" color="success"
                                                    style={{ fontSize: 16, padding: "9px 18px", fontWeight: "bold" }}
                                                    disabled={!singleItemSelect.item_name}
                                                    onClick={() => openSingleItemExtraDetailModel(singleItemSelect.id, singleItemSelect.item_name)}>
                                                    {/* <i className="bi bi-plus mr-1"></i> */}
                                                    E</Button>}

                                                {/* <Button type="button" className="mt-2" color="primary"
                                                style={{ fontSize: 16 }}
                                                disabled={!singleItemSelect.recv_qty}
                                                onClick={() => AddSingleItemSelect()}> {singleItemEditMode ? "Update" : "Save"}</Button> */}


                                                <Button type="button" className="mt-2" color="danger"
                                                    style={{ fontSize: 16, padding: "9px 18px", fontWeight: "bold" }}
                                                    disabled={challanMasterData.challan_by == "RECEIVE_CHALLAN"}
                                                    onClick={() => RemoveSingleArraySelectItem(index)}>D</Button>

                                                {System_Records_receipted_data?.warranty_button == "yes" && <Button type="button" className="mt-2" color="primary"
                                                    style={{ fontSize: 16, padding: "9px 18px", fontWeight: "bold" }}
                                                    disabled={((!singleItemSelect.recv_qty && !singleItemSelect.issue_qty) && !singleItemSelect.item_warranty_visit_count)}
                                                    onClick={() => OpenWarrantyModel(singleItemSelect.item_code, singleItemSelect.item_name)}
                                                >
                                                    {/* <i className="bi bi-plus mr-1"></i> */}
                                                    W</Button>}


                                                <Button
                                                    type="button"
                                                    className="mt-2"
                                                    color="primary"
                                                    style={{ fontSize: 16, padding: "9px 18px", fontWeight: "bold" }}
                                                    onClick={() => OpenSingleItemDetailModel(index)}
                                                    disabled={!singleItemSelect.recv_qty && !singleItemSelect.issue_qty}
                                                >
                                                    <i className="bi bi-save"></i>
                                                </Button>

                                            </FormGroup>
                                            {/*  <Col xs={12} sm={6} md={4} lg={2} className="mb-2"> */}


                                            {/* </td> */}
                                        </Col>}


                                        {System_Records_receipted_data?.hsn_code_yn == "yes" &&
                                            <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                                <FormGroup>
                                                    <Label style={{ fontSize: 14 }} for="item_hsn_code_one_pc">HSN Code</Label>
                                                    <Input
                                                        id="item_hsn_code_one_pc"
                                                        name="item_hsn_code_one_pc"
                                                        type="text"
                                                        onChange={(e) => updateSingleArrayItem(index, "item_hsn_code_one_pc", e.target.value)}
                                                        value={singleItemSelect.item_hsn_code_one_pc}
                                                        disabled
                                                        style={{ fontSize: 14 }}
                                                    />
                                                </FormGroup>
                                            </Col>}


                                        {System_Records_receipted_data?.packing_type_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="item_packing_type_one_pc">Packing Type</Label>
                                                <Input
                                                    id="item_packing_type_one_pc"
                                                    name="item_packing_type_one_pc"
                                                    type="text"


                                                    onChange={(e) => updateSingleArrayItem(index, "item_packing_type_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.item_packing_type_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />

                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.scheme_type_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="item_scheme_type_one_pc">Scheme Type</Label>
                                                <Input
                                                    id="item_scheme_type_one_pc"
                                                    name="item_scheme_type_one_pc"
                                                    type="select" className="custom-select"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}

                                                    onChange={(e) => updateSingleArrayItem(index, "item_scheme_type_one_pc", e.target.value)}

                                                    value={singleItemSelect.item_scheme_type_one_pc}
                                                    style={{ fontSize: 14 }}
                                                >
                                                    <option value="">Select</option>
                                                    {helperMasterSingleItem.length != 0 && helperMasterSingleItem.map((option) => (
                                                        <option key={option.id} value={option.field_data}>
                                                            {option.field_data}
                                                        </option>
                                                    ))}
                                                </Input>

                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.remarks_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="item_remarks_one_pc">Remarks</Label>
                                                <Input
                                                    id="item_remarks_one_pc"
                                                    name="item_remarks_one_pc"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "item_remarks_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.item_remarks_one_pc}
                                                    style={{ fontSize: 14 }}

                                                />
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.purchase_rate_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_purchase_one_pc">Purchase Rate</Label>
                                                <Input
                                                    id="item_purchase_one_pc"
                                                    name="item_purchase_one_pc"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "item_purchase_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeItemHandle(e) }}
                                                    value={singleItemSelect?.item_purchase_one_pc || ""}
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />

                                            </FormGroup>
                                        </Col>}


                                        {System_Records_receipted_data?.sale_rate_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="rent_rate">Rate</Label>
                                                <Input
                                                    id="rent_rate"
                                                    name="rent_rate"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "rent_rate", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect?.rent_rate || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                                {/* {itemErrorMessage.rent_rate && (
                                                                                    <FormText color="danger">{itemErrorMessage.rent_rate}</FormText>
                                                                                )} */}
                                            </FormGroup>
                                        </Col>}


                                        {System_Records_receipted_data?.profit_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_profit_one_pc">Profit</Label>
                                                <Input
                                                    id="item_profit_one_pc"
                                                    name="item_profit_one_pc"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "item_profit_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect?.item_profit_one_pc || ""}
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />
                                                {/* {itemErrorMessage.item_profit_one_pc && (
                                                                                        <FormText color="danger">{itemErrorMessage.item_profit_one_pc}</FormText>
                                                                                    )} */}
                                            </FormGroup>
                                        </Col>}



                                        {System_Records_receipted_data?.issue_qty_yn == "yes" &&

                                            <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                                <FormGroup>
                                                    <Label style={{ fontSize: 14 }} for="issue_qty">Qty</Label> {singleItemSelect.item_code && <Label style={{ color: "red" }}>(*)</Label>}
                                                    <Input
                                                        id="issue_qty"
                                                        name="issue_qty"
                                                        type="number"
                                                        onChange={(e) => updateSingleArrayItem(index, "issue_qty", e.target.value)}

                                                        // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                        value={singleItemSelect?.issue_qty || ""}
                                                        style={{ fontSize: 14 }}
                                                    />
                                                    {/* {itemErrorMessage.price_sell_rate && (
                                                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                )} */}
                                                </FormGroup>
                                            </Col>}

                                        {System_Records_receipted_data?.recv_qty_yn == "yes" &&
                                            <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                                <FormGroup>
                                                    <Label style={{ fontSize: 14 }} for="recv_qty">Qty</Label>
                                                    {singleItemSelect.item_code && <Label style={{ color: "red" }}>(*)</Label>}
                                                    <Input
                                                        id="recv_qty"
                                                        name="recv_qty"
                                                        type="number"
                                                        onChange={(e) => updateSingleArrayItem(index, "recv_qty", e.target.value)}

                                                        // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                        value={singleItemSelect?.recv_qty || ""}
                                                        style={{ fontSize: 14 }}
                                                    />
                                                    {/* {itemErrorMessage.price_sell_rate && (
                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                )} */}
                                                </FormGroup>
                                            </Col>}

                                        {System_Records_receipted_data?.discount_percentage_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_discount_percentage_one_pc">Disc %</Label>
                                                <Input
                                                    id="item_discount_percentage_one_pc"
                                                    name="item_discount_percentage_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    // onChange={(e) => updateSingleArrayItem(index, "item_discount_percentage_one_pc", e.target.value)}
                                                    min={0}
                                                    max={100}
                                                    onChange={(e) => {
                                                        let value = Number(e.target.value);
                                                        if (value < 0) value = 0;
                                                        if (value > 100) value = 100;
                                                        updateSingleArrayItem(index, "item_discount_percentage_one_pc", value);
                                                    }}
                                                    value={singleItemSelect?.item_discount_percentage_one_pc || ""}
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                        <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                    )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.discount_amount_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_discount_amount_one_pc_one_pc">Discount Amt</Label>
                                                <Input
                                                    id="item_discount_amount_one_pc"
                                                    name="item_discount_amount_one_pc"
                                                    type="number"

                                                    onChange={(e) => updateSingleArrayItem(index, "item_discount_amount_one_pc", e.target.value)}


                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect?.item_discount_amount_one_pc || ""}
                                                    style={{ fontSize: 14 }}
                                                    disabled
                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                )} */}
                                            </FormGroup>
                                        </Col>}
                                        {/* </tr>
                                                                            <tr> */}



                                        {System_Records_receipted_data?.discount_rate_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_discount_rate_one_pc">Discount Rate</Label>
                                                <Input
                                                    id="item_discount_rate_one_pc"
                                                    name="item_discount_rate_one_pc"
                                                    type="number"

                                                    onChange={(e) => updateSingleArrayItem(index, "item_discount_rate_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect?.item_discount_rate_one_pc || ""}
                                                    style={{ fontSize: 14 }}
                                                    disabled

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                        <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                    )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.grand_total_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_gross_amount_one_pc">Gross Tot</Label>
                                                <Input
                                                    id="item_gross_amount_one_pc"
                                                    name="item_gross_amount_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}

                                                    onChange={(e) => updateSingleArrayItem(index, "item_gross_amount_one_pc", e.target.value)}

                                                    value={singleItemSelect.item_gross_amount_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                )} */}
                                            </FormGroup>
                                        </Col>}


                                        {System_Records_receipted_data?.gst_percentage_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_gst_percenatge_one_pc">Gst %</Label>
                                                <Input
                                                    id="item_gst_percenatge_one_pc"
                                                    name="item_gst_percenatge_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    // onChange={(e) => updateSingleArrayItem(index, "item_gst_percenatge_one_pc", e.target.value)}

                                                    min={0}
                                                    max={100}
                                                    onChange={(e) => {
                                                        let value = Number(e.target.value);
                                                        if (value < 0) value = 0;
                                                        if (value > 100) value = 100;
                                                        updateSingleArrayItem(index, "item_gst_percenatge_one_pc", value);
                                                    }}
                                                    value={singleItemSelect.item_gst_percenatge_one_pc}
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                        <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                    )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.gst_amount_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_gst_amt_one_pc">Gst Amt</Label>
                                                <Input
                                                    id="item_gst_amt_one_pc"
                                                    name="item_gst_amt_one_pc"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "item_gst_amt_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.item_gst_amt_one_pc}
                                                    style={{ fontSize: 14 }}
                                                    disabled

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.gst_rate_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label
                                                    style={{ fontSize: 14 }}
                                                    for="item_gst_rate_one_pc">Gst Rate</Label>
                                                <Input
                                                    id="item_gst_rate_one_pc"
                                                    name="item_gst_rate_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}

                                                    onChange={(e) => updateSingleArrayItem(index, "item_gst_rate_one_pc", e.target.value)}

                                                    value={singleItemSelect.item_gst_rate_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                        <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                    )} */}
                                            </FormGroup>
                                        </Col>}
                                        {/* </tr>
    
                                                                            <tr> */}

                                        {System_Records_receipted_data?.rate_after_gst_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label
                                                    style={{ fontSize: 14 }}
                                                    for="item_rate_after_gst_one_pc">Rate After Gst</Label>
                                                <Input
                                                    id="item_rate_after_gst_one_pc"
                                                    name="item_rate_after_gst_one_pc"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "item_rate_after_gst_one_pc", e.target.value)}


                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.item_rate_after_gst_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                            )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.total_amount_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="total_amount_with_gst_one_pc">Tot Amt</Label>
                                                <Input
                                                    id="total_amount_with_gst_one_pc"
                                                    name="total_amount_with_gst_one_pc"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "total_amount_with_gst_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.total_amount_with_gst_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                        <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                    )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.total_profit_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="profit_amount_one_pc">Tot Profit</Label>
                                                <Input
                                                    id="profit_amount_one_pc"
                                                    name="profit_amount_one_pc"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "profit_amount_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.profit_amount_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />

                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.total_weight_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="totalWeight">Tot Wt</Label>
                                                <Input
                                                    id="totalWeight"
                                                    name="totalWeight"
                                                    type="text"

                                                    onChange={(e) => updateSingleArrayItem(index, "totalWeight", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.totalWeight || ""}
                                                    // value={singleItemSelect.recv_qty ? singleItemSelect.item_weight_one_pc * singleItemSelect.recv_qty :singleItemSelect.item_weight_one_pc  }
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />

                                            </FormGroup>
                                        </Col>}




                                        {System_Records_receipted_data?.current_stock_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Current Stock</Label>
                                                <Input
                                                    id=""
                                                    name=""
                                                    type="text"
                                                    // onChange={(e) => updateSingleArrayItem(index, "item_weight_one_pc", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.item_current_stock || ""}
                                                    // value={singleItemSelect.recv_qty ? singleItemSelect.item_weight_one_pc * singleItemSelect.recv_qty :singleItemSelect.item_weight_one_pc  }
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>}

                                        {/* </tr>
    
                                                                            <tr> */}
                                        {System_Records_receipted_data?.balance_qty_yn == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Bal Qty</Label>
                                                <Input
                                                    id=""
                                                    name=""
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.opening_qty || ""}
                                                    // value={singleItemSelect.recv_qty ? singleItemSelect.item_weight_one_pc * singleItemSelect.recv_qty :singleItemSelect.item_weight_one_pc  }
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>}



                                        {/*  add new key */}
                                        {System_Records_receipted_data?.warranty_period == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="">Warranty Period</Label>
                                                <Input
                                                    id="item_warranty_period"
                                                    name="item_warranty_period"
                                                    type="select" className="custom-select"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    onChange={(e) => updateSingleArrayItem(index, "item_warranty_period", e.target.value)}

                                                    value={singleItemSelect.item_warranty_period || ""}
                                                    style={{ fontSize: 14 }}
                                                >
                                                    <option value="">Select</option>
                                                    {helperMasterSingleItemWarrantyPeriod.length != 0 && helperMasterSingleItemWarrantyPeriod.map((option) => (
                                                        <option key={option.id} value={option.field_data}>
                                                            {option.field_data}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.warranty_mode == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Warranty Mode</Label>
                                                <Input
                                                    id="item_warranty_mode"
                                                    name="item_warranty_mode"
                                                    type="select" className="custom-select"
                                                    onChange={(e) => updateSingleArrayItem(index, "item_warranty_mode", e.target.value)}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={singleItemSelect.item_warranty_mode || ""}
                                                    style={{ fontSize: 14 }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="online">Online</option>
                                                    <option value="offline">Offline</option>

                                                </Input>
                                            </FormGroup>
                                        </Col>}



                                        {System_Records_receipted_data?.service_visit_count == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Service Visit Count</Label>
                                                <Input
                                                    id="item_warranty_visit_count"
                                                    name="item_warranty_visit_count"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    onChange={(e) => updateSingleArrayItem(index, "item_warranty_visit_count", e.target.value)}

                                                    value={singleItemSelect.item_warranty_visit_count || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        }

                                        {System_Records_receipted_data?.warranty_expiry_date == "yes" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Warranty Expiry Date</Label>
                                                <Input
                                                    id="item_warranty_expiry_date"
                                                    name="item_warranty_expiry_date"
                                                    type="date"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}

                                                    onChange={(e) => updateSingleArrayItem(index, "item_warranty_expiry_date", e.target.value)}

                                                    value={singleItemSelect.item_warranty_expiry_date?.split('T')[0] || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>}


                                        {/*  ================ puchase invoice keyword add =============== */}

                                        {/* <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}>Item Image</Label>
                                                {singleItemSelect.item_image && (
                                                    <img
                                                        src={API_URL + singleItemSelect.item_image}
                                                        alt="Preview"
                                                        style={{ width: "80px", height: "80px", marginTop: "5px", borderRadius: "4px" }}
                                                    />
                                                )}
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}>Make</Label>
                                                <Input
                                                    
                                                    id="item_make"
                                                    name="item_make"
                                                    type="text"
                                                    value={singleItemSelect.item_make || ""}
                                                    onChange={(e) => updateSingleArrayItem(index, "item_make", e.target.value)}

                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>

                                        <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}>Size</Label>
                                                <Input
                                                    
                                                    id="item_size"
                                                    name="item_size"
                                                    type="text"
                                                    step="0.01"
                                                    value={singleItemSelect.item_size || ""}
                                                    onChange={(e) => updateSingleArrayItem(index, "item_size", e.target.value)}

                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}>Thickness</Label>
                                                <Input
                                                    
                                                    id="item_thickness"
                                                    name="item_thickness"
                                                    type="number"
                                                    step="0.01"
                                                    value={singleItemSelect.item_thickness || ""}
                                                    onChange={(e) => updateSingleArrayItem(index, "item_thickness", e.target.value)}

                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}>Width</Label>
                                                <Input
                                                    
                                                    id="item_width"
                                                    name="item_width"
                                                    type="number"
                                                    step="0.01"
                                                    value={singleItemSelect.item_width || ""}
                                                    onChange={(e) => updateSingleArrayItem(index, "item_width", e.target.value)}

                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}>Length</Label>
                                                <Input
                                                    
                                                    id="item_length"
                                                    name="item_length"
                                                    type="number"
                                                    step="0.01"
                                                    value={singleItemSelect.item_length || ""}
                                                    onChange={(e) => updateSingleArrayItem(index, "item_length", e.target.value)}

                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col> */}



                                        {/*  <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            {System_Records_receipted_data?.extra_detail_button == "yes" && <Button type="button" className="mt-2" color="success"
                                                style={{ fontSize: 14 }}
                                                disabled={!singleItemSelect.item_name}
                                                onClick={() => openSingleItemExtraDetailModel(singleItemSelect.id, singleItemSelect.item_name)}>
                                                {/* <i className="bi bi-plus mr-1"></i> */}
                                        {/* E</Button>} */}

                                        {/* <Button type="button" className="mt-2" color="primary"
                                                style={{ fontSize: 14 }}
                                                disabled={!singleItemSelect.recv_qty}
                                                onClick={() => AddSingleItemSelect()}> {singleItemEditMode ? "Update" : "Save"}</Button> */}


                                        {/* <Button type="button" className="mt-2" color="danger"
                                                style={{ fontSize: 14 }}
                                                disabled={!singleItemSelect.recv_qty && !singleItemSelect.issue_qty}
                                                onClick={() => RemoveSingleArraySelectItem(index)}>D</Button>

                                            {System_Records_receipted_data?.warranty_button == "yes" && <Button type="button" className="mt-2" color="primary"
                                                style={{ fontSize: 14 }}
                                                disabled={((!singleItemSelect.recv_qty && !singleItemSelect.issue_qty) && !singleItemSelect.item_warranty_visit_count)}
                                                onClick={() => OpenWarrantyModel(singleItemSelect.item_code, singleItemSelect.item_name)}
                                            >
                                                {/* <i className="bi bi-plus mr-1"></i> */}
                                        {/* W</Button>} */}


                                        {/* <Button
                                                type="button"
                                                className="mt-2"
                                                color="primary"
                                                style={{ fontSize: 14 }}
                                                onClick={() => OpenSingleItemDetailModel(index)}
                                                disabled={!singleItemSelect.recv_qty && !singleItemSelect.issue_qty}
                                            >
                                                <i className="bi bi-save mr-1"></i>
                                            </Button>

                                        //</Col> */}

                                        {/* ============= challan party =========== */}
                                        {(nextPartyOption && singleItemSelect.id) &&
                                            <Row style={{
                                                backgroundColor: "#fff3e0",
                                                margin: "0 auto",
                                                borderRadius: 12,
                                                // padding: 15,
                                                // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                                                width: "97%",
                                                marginBottom: 10
                                            }}>

                                                <p className="text-danger">*** For Direct Issue Challan Entry</p>

                                                <Col sm={9}>
                                                    <FormGroup>
                                                        <Label for="pname">Party Name</Label>

                                                        <Autocomplete
                                                            size="small"
                                                            autoHighlight
                                                            id="next_challan_party_id"
                                                            name="next_challan_party_id"
                                                            options={partyTable || []} // Ensure options are never undefined
                                                            getOptionLabel={(option) => `${option.name} - ${option.party_agr_code}-${option.party_company_name} - ${option.mobile_number}`} // Correct concatenation
                                                            renderInput={(params) => (
                                                                <TextField {...params} placeholder="Select Party Code" />
                                                            )}
                                                            renderOption={(props, option, { index }) => (
                                                                <li {...props} key={option.id || index}>
                                                                    {`${option.name} - ${option.party_agr_code}- ${option.party_company_name}- ${option.mobile_number}`} {/* Correct concatenation */}
                                                                </li>
                                                            )}
                                                            value={partyTable.find(option => option.id === singleItemSelect?.next_challan_party_id) || null}
                                                            onChange={(event, value) => {
                                                                // handleCusotmerName(event, value);
                                                                updateSingleArrayItem(index, "next_challan_party_id", value)

                                                            }}

                                                        // readOnly={singleItemSelectArray.length != 0}
                                                        />
                                                    </FormGroup>
                                                </Col>

                                                <Col sm={2}>
                                                    <FormGroup>

                                                        <Label for="next_challan_no">Bill No</Label>
                                                        <Input type="text" name="next_challan_no" id="next_challan_no"
                                                            value={singleItemSelect.next_challan_no || ''}
                                                            onChange={(e) => updateSingleArrayItem(index, "next_challan_no", e.target.value)}

                                                        />


                                                    </FormGroup>
                                                </Col>

                                                <Col sm={1}>
                                                    <Label>Action</Label>
                                                    <Button
                                                        color="danger"
                                                        className="mr-2"
                                                        onClick={() => handleRemoveNextChallanData(singleItemSelect.id)}
                                                    >
                                                        <i className="bi bi-trash"></i>
                                                        {/* <p style={{ fontSize: 8, padding: 0, margin: 0, fontWeight: "bold" }}>Delete</p> */}

                                                    </Button>
                                                </Col>

                                            </Row>
                                        }


                                        {/* actions buttons */}
                                        {/* Action buttons */}

                                        {/* 
                                        </tr>
                                    </tbody>
                                </Table> */}
                                    </Row>


                                    <hr className="mt-2 mb-2" />
                                    <div className="d-flex flex-wrap gap-2 justify-content-end">

                                        {System_Records_receipted_data?.extra_detail_button == "yes" && <Button type="button" className="mt-2" color="success"
                                            style={{ fontSize: 14 }}
                                            disabled={!singleItemSelect.item_name}
                                            onClick={() => openSingleItemExtraDetailModel(singleItemSelect.id, singleItemSelect.item_name)}>
                                            <i className="bi bi-question-circle mr-1"></i>
                                            Extra details</Button>}


                                        <Button type="button" className="mt-2" color="danger"
                                            style={{ fontSize: 14 }}
                                            disabled={challanMasterData.challan_by == "RECEIVE_CHALLAN"}
                                            onClick={() => RemoveSingleArraySelectItem(index)}><i className="bi bi-trash"> Remove Item</i></Button>

                                        {System_Records_receipted_data?.warranty_button == "yes" && <Button type="button" className="mt-2" color="primary"
                                            style={{ fontSize: 14 }}
                                            disabled={((!singleItemSelect.recv_qty && !singleItemSelect.issue_qty) && !singleItemSelect.item_warranty_visit_count)}
                                            onClick={() => OpenWarrantyModel(singleItemSelect.item_code, singleItemSelect.item_name)}
                                        >
                                            {/* <i className="bi bi-plus mr-1"></i> */}
                                            Warranty Details</Button>}


                                        <Button
                                            type="button"
                                            className="mt-2"
                                            color="primary"
                                            style={{ fontSize: 14 }}
                                            onClick={() => OpenSingleItemDetailModel(index)}
                                            disabled={!singleItemSelect.recv_qty && !singleItemSelect.issue_qty}
                                        >
                                            <i className="bi bi-eye mr-1"> More Details</i>
                                        </Button>

                                    </div>

                                </div>
                            </div>
                        )})}
                    

                        <div className="text-center">
                            <Button color="primary" onClick={addMore}>+ Add more Rows</Button>

                        </div>
                    </div>
                </Collapse>

            </div>


            <CustomModal
                show={showSingleItemDetailModel}
                title={"this is edit mode"}
                onCancel={ClosedSingleItemDetailModel}
                // onConfirm={confirmModal}
                content=<div>
                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-bell mr-2"></i>
                            Show Item Detail
                        </div>
                    </CardTitle>
                    <CardBody>
                        <div>
                            <Col>
                                <FormGroup style={{ padding: 10 }} > {/* Adjust width as needed */}
                                    <Label style={{ fontSize: 14 }} for="item_name">Item Name</Label>
                                    <Autocomplete
                                        id="item_name"
                                        name="item_name"
                                        options={itemTable.map((option) => ({ id: option.id, label: option.item_name }))}
                                        renderInput={(params) => <TextField {...params} size="small" />}
                                        value={showSingleItemDetail.item_name || ''}
                                        // onChange={handleSingleItem}
                                        style={{ fontSize: 14 }}
                                    // disable={!challanMasterData.pname}
                                    />
                                    {/* {itemErrorMessage.item_name && (
                                                                                          <FormText color="danger">{itemErrorMessage.item_name}</FormText>
                                                                                      )} */}
                                </FormGroup>
                            </Col>


                            {/* No Item Show  */}

                            <Table striped>
                                <tbody >
                                    <tr style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        {System_Records_receipted_data?.hsn_code_yn == "no" &&
                                            <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                                <FormGroup>
                                                    <Label style={{ fontSize: 14 }}
                                                        for="item_hsn_code_one_pc">HSN Code</Label>
                                                    <Input
                                                        id="item_hsn_code_one_pc"
                                                        name="item_hsn_code_one_pc"
                                                        type="text"
                                                        // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                        value={showSingleItemDetail.item_hsn_code_one_pc}
                                                        disabled
                                                        style={{ fontSize: 14 }}

                                                    />

                                                </FormGroup>
                                            </Col>}


                                        {System_Records_receipted_data?.packing_type_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="item_packing_type_one_pc">Packing Type</Label>
                                                <Input
                                                    id="item_packing_type_one_pc"
                                                    name="item_packing_type_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_packing_type_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />

                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.scheme_type_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="item_scheme_type_one_pc">Scheme Type</Label>
                                                <Input
                                                    id="item_scheme_type_one_pc"
                                                    name="item_scheme_type_one_pc"
                                                    type="select" className="custom-select"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_scheme_type_one_pc}
                                                    style={{ fontSize: 14 }}
                                                >
                                                    <option value="">Select</option>
                                                    {helperMasterSingleItem.length != 0 && helperMasterSingleItem.map((option) => (
                                                        <option key={option.id} value={option.field_data}>
                                                            {option.field_data}
                                                        </option>
                                                    ))}
                                                </Input>

                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.remarks_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="item_remarks_one_pc">Remarks</Label>
                                                <Input
                                                    id="item_remarks_one_pc"
                                                    name="item_remarks_one_pc"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_remarks_one_pc}
                                                    style={{ fontSize: 14 }}

                                                />
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.purchase_rate_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_purchase_one_pc">Purchase Rate</Label>
                                                <Input
                                                    id="item_purchase_one_pc"
                                                    name="item_purchase_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeItemHandle(e) }}
                                                    value={showSingleItemDetail?.item_purchase_one_pc || ""}
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />
                                                {/* {itemErrorMessage.item_purchase_one_pc && (
                                                                                                          <FormText color="danger">{itemErrorMessage.item_purchase_one_pc}</FormText>
                                                                                                      )} */}
                                            </FormGroup>
                                        </Col>}

                                        {/* </tr>
                      
                                                                                              <tr> */}


                                        {System_Records_receipted_data?.sale_rate_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="rent_rate">Rate</Label>
                                                <Input
                                                    id="rent_rate"
                                                    name="rent_rate"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail?.rent_rate || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                                {/* {itemErrorMessage.rent_rate && (
                                                                                                      <FormText color="danger">{itemErrorMessage.rent_rate}</FormText>
                                                                                                  )} */}
                                            </FormGroup>
                                        </Col>}


                                        {System_Records_receipted_data?.profit_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_profit_one_pc">Profit</Label>
                                                <Input
                                                    id="item_profit_one_pc"
                                                    name="item_profit_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail?.item_profit_one_pc || ""}
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />
                                                {/* {itemErrorMessage.item_profit_one_pc && (
                                                                                                          <FormText color="danger">{itemErrorMessage.item_profit_one_pc}</FormText>
                                                                                                      )} */}
                                            </FormGroup>
                                        </Col>}


                                        {System_Records_receipted_data?.issue_qty_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="issue_qty">Qty</Label> {showSingleItemDetail.item_code && <Label style={{ color: "red" }}>(mandatory)</Label>}
                                                <Input
                                                    id="issue_qty"
                                                    name="issue_qty"
                                                    type="number"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail?.issue_qty || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                )} */}
                                            </FormGroup>
                                        </Col>}



                                        {System_Records_receipted_data?.recv_qty_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="recv_qty">Qty</Label> {showSingleItemDetail.item_code && <Label style={{ color: "red" }}>(*)</Label>}
                                                <Input
                                                    id="recv_qty"
                                                    name="recv_qty"
                                                    type="number"
                                                    // onChange={(e) => updateSingleArrayItem(index, "recv_qty", e.target.value)}
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}

                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail?.recv_qty || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                    <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                )} */}
                                            </FormGroup>
                                        </Col>}



                                        {System_Records_receipted_data?.discount_percentage_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_discount_percentage_one_pc">Discount %</Label>
                                                <Input
                                                    id="item_discount_percentage_one_pc"
                                                    name="item_discount_percentage_one_pc"
                                                    type="number"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail?.item_discount_percentage_one_pc || ""}
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                          <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                      )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.discount_amount_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_discount_amount_one_pc_one_pc">Discount Amt</Label>
                                                <Input
                                                    id="item_discount_amount_one_pc"
                                                    name="item_discount_amount_one_pc"
                                                    type="number"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail?.item_discount_amount_one_pc || ""}
                                                    style={{ fontSize: 14 }}
                                                    disabled
                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                      <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                  )} */}
                                            </FormGroup>
                                        </Col>}
                                        {/* </tr>
                                                                                              <tr> */}



                                        {System_Records_receipted_data?.discount_rate_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_discount_rate_one_pc">Discount Rate</Label>
                                                <Input
                                                    id="item_discount_rate_one_pc"
                                                    name="item_discount_rate_one_pc"
                                                    type="number"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail?.item_discount_rate_one_pc || ""}
                                                    style={{ fontSize: 14 }}
                                                    disabled

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                          <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                      )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.grand_total_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_gross_amount_one_pc">Grs. Tot</Label>
                                                <Input
                                                    id="item_gross_amount_one_pc"
                                                    name="item_gross_amount_one_pc"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_gross_amount_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                      <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                  )} */}
                                            </FormGroup>
                                        </Col>}


                                        {System_Records_receipted_data?.gst_percentage_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_gst_percenatge_one_pc">Gst %</Label>
                                                <Input
                                                    id="item_gst_percenatge_one_pc"
                                                    name="item_gst_percenatge_one_pc"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_gst_percenatge_one_pc}
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                          <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                      )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.gst_amount_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="item_gst_amt_one_pc">Gst Amt</Label>
                                                <Input
                                                    id="item_gst_amt_one_pc"
                                                    name="item_gst_amt_one_pc"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_gst_amt_one_pc}
                                                    style={{ fontSize: 14 }}
                                                    disabled

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                      <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                  )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.gst_rate_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label
                                                    style={{ fontSize: 14 }}
                                                    for="item_gst_rate_one_pc">Gst Rate</Label>
                                                <Input
                                                    id="item_gst_rate_one_pc"
                                                    name="item_gst_rate_one_pc"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_gst_rate_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                          <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                      )} */}
                                            </FormGroup>
                                        </Col>}
                                        {/* </tr>
                      
                                                                                              <tr> */}

                                        {System_Records_receipted_data?.rate_after_gst_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label
                                                    style={{ fontSize: 14 }}
                                                    for="item_rate_after_gst_one_pc">Rate After Gst</Label>
                                                <Input
                                                    id="item_rate_after_gst_one_pc"
                                                    name="item_rate_after_gst_one_pc"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_rate_after_gst_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                                  <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                              )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.total_amount_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="total_amount_with_gst_one_pc">Tot Amt</Label>
                                                <Input
                                                    id="total_amount_with_gst_one_pc"
                                                    name="total_amount_with_gst_one_pc"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.total_amount_with_gst_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />
                                                {/* {itemErrorMessage.price_sell_rate && (
                                                                                                          <FormText color="danger">{itemErrorMessage.price_sell_rate}</FormText>
                                                                                                      )} */}
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.total_profit_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="profit_amount_one_pc">Tot Profit</Label>
                                                <Input
                                                    id="profit_amount_one_pc"
                                                    name="profit_amount_one_pc"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.profit_amount_one_pc}
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />

                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.total_weight_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="totalWeight">Tot Wt</Label>
                                                <Input
                                                    id="totalWeight"
                                                    name="totalWeight"
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.totalWeight || ""}
                                                    // value={showSingleItemDetail.issue_qty ? showSingleItemDetail.totalWeight * showSingleItemDetail.issue_qty :showSingleItemDetail.item_weight_one_pc  }
                                                    disabled
                                                    style={{ fontSize: 14 }}

                                                />

                                            </FormGroup>
                                        </Col>}




                                        {System_Records_receipted_data?.current_stock_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Current Stock</Label>
                                                <Input
                                                    id=""
                                                    name=""
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_current_stock || ""}
                                                    // value={showSingleItemDetail.issue_qty ? showSingleItemDetail.item_weight_one_pc * showSingleItemDetail.issue_qty :showSingleItemDetail.item_weight_one_pc  }
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />


                                            </FormGroup>
                                        </Col>}

                                        {/* </tr>
                      
                                                                                              <tr> */}
                                        {System_Records_receipted_data?.balance_qty_yn == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Bal Qty</Label>
                                                <Input
                                                    id=""
                                                    name=""
                                                    type="text"
                                                    // onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.opening_qty || ""}
                                                    // value={showSingleItemDetail.issue_qty ? showSingleItemDetail.item_weight_one_pc * showSingleItemDetail.issue_qty :showSingleItemDetail.item_weight_one_pc  }
                                                    disabled
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>}



                                        {/*  add new key */}
                                        {System_Records_receipted_data?.warranty_period == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }} for="">Warranty Period</Label>
                                                <Input
                                                    id="item_warranty_period"
                                                    name="item_warranty_period"
                                                    type="select" className="custom-select"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_warranty_period || ""}
                                                    style={{ fontSize: 14 }}
                                                >
                                                    <option value="">Select</option>
                                                    {helperMasterSingleItemWarrantyPeriod.length != 0 && helperMasterSingleItemWarrantyPeriod.map((option) => (
                                                        <option key={option.id} value={option.field_data}>
                                                            {option.field_data}
                                                        </option>
                                                    ))}
                                                </Input>
                                            </FormGroup>
                                        </Col>}

                                        {System_Records_receipted_data?.warranty_mode == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Warranty Mode</Label>
                                                <Input
                                                    id="item_warranty_mode"
                                                    name="item_warranty_mode"
                                                    type="select" className="custom-select"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_warranty_mode || ""}
                                                    style={{ fontSize: 14 }}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="online">Online</option>
                                                    <option value="offline">Offline</option>

                                                </Input>
                                            </FormGroup>
                                        </Col>}



                                        {System_Records_receipted_data?.service_visit_count == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Service Visit Count</Label>
                                                <Input
                                                    id="item_warranty_visit_count"
                                                    name="item_warranty_visit_count"
                                                    type="text"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_warranty_visit_count || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>
                                        }

                                        {System_Records_receipted_data?.warranty_expiry_date == "no" && <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            <FormGroup>
                                                <Label style={{ fontSize: 14 }}
                                                    for="">Warranty Expiry Date</Label>
                                                <Input
                                                    id="item_warranty_expiry_date"
                                                    name="item_warranty_expiry_date"
                                                    type="date"
                                                    onChange={(e) => { onChangeSingleItemHandle(e) }}
                                                    value={showSingleItemDetail.item_warranty_expiry_date?.split('T')[0] || ""}
                                                    style={{ fontSize: 14 }}
                                                />
                                            </FormGroup>
                                        </Col>}


                                        {/*  <Col xs={12} sm={6} md={4} lg={2} className="mb-2">
                                            {System_Records_receipted_data?.extra_detail_button == "no" && <Button type="button" className="mt-2" color="success"
                                                disabled={!showSingleItemDetail.item_name}
                                                onClick={() => openSingleItemExtraDetailModel(showSingleItemDetail.id, showSingleItemDetail.item_name)}>Add Extra Detail</Button>}

                                            <Button type="button" className="mt-2" color="primary"
                                                disabled={!showSingleItemDetail.issue_qty}
                                                onClick={() => AddSingleItemSelect()}> {singleItemEditMode ? "Update" : "Save"}</Button>

                                            {System_Records_receipted_data?.warranty_button == "no" && <Button type="button" className="mt-2" color="primary"
                                                disabled={(!showSingleItemDetail.issue_qty && !showSingleItemDetail.item_warranty_visit_count)}
                                                onClick={() => OpenWarrantyModel(showSingleItemDetail.item_code, showSingleItemDetail.item_name)}
                                            >Add Warranty</Button>}
                                       </Col> */}
                                    </tr>
                                </tbody>
                            </Table>

                        </div>
                    </CardBody>
                </div>
            />

        </>
    );
};

export default SingleItemArray;
